import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]




export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSwitcher',
  props: /*@__PURE__*/_mergeModels({
  readOnly: {
    type: Boolean,
    default: false,
  },
}, {
    "modelValue": { default: false },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const isActive = _useModel(__props, "modelValue");



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["switcher-container", { '--active': isActive.value, '--read-only': __props.readOnly }])
  }, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isActive).value = $event)),
      disabled: __props.readOnly,
      type: "checkbox"
    }, null, 8, _hoisted_1), [
      [_vModelCheckbox, isActive.value]
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "switcher-container__bounce" }, null, -1))
  ], 2))
}
}

})